import { motion } from 'framer-motion';
import React, { useState, useEffect } from "react";
import "./consultancy.css";

const Consultancy = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const testimonials = [
    { 
      name: 'Parent of Grade 11 Student, Dubai',
      role: 'Parent',
      text: "We were overwhelmed with the number of SAT prep options out there. Engagehub helped us connect with a trusted coaching provider within days. My daughter not only improved her SAT score by 200 points but also felt much more confident going into the exam. Engagehub made the whole process stress-free"
    },
    { 
      name: 'Parent of Grade 12 Student, Abu Dhabi',
      role: 'Parent',
      text: "Finding the right counsellor was always a challenge. Through Engagehub, we found a counsellor who perfectly understood my son's aspirations and guided him with college selection, essays, and applications. The personal attention and expertise made a world of difference. We are very grateful to Engagehub for bridging that gap"
    },
    { 
      name: 'Parent of High School Junior, Sharjah', 
      role: 'Parent',
      text: "As parents, we wanted reliable and well-reviewed services for our child. Engagehub gave us peace of mind by connecting us to vetted SAT prep companies and counsellors. Instead of spending weeks researching, we got the right match in just a couple of conversations. Truly a one-stop solution"
    },
    { 
      name: 'Parent of Student',
      role: 'Parent',
      text: "Thanks to Engagehub, my daughter not only secured an excellent SAT score but also got admission counselling that helped her craft a strong application. She has now received offers from her top-choice universities. Engagehub was the perfect partner in this journey."
    },
    { 
      name: 'Parent of Grade 12 Student, Abu Dhabi',
      role: 'Parent',
      text: "Engagehub made the daunting college admissions process so much easier. The counsellor we were matched with gave clear guidance on essays, applications, and university shortlisting. My daughter has already received offers from her top-choice schools. Couldn't have asked for a better experience."
    },
    { 
      name: 'Parent of IBDP Year 1 Student, Dubai',
      role: 'Parent',
      text: "The IB Diploma can be overwhelming, especially with subjects like HL Math and Physics. Through Engagehub, we found an excellent tutor who made complex concepts clear and boosted my son's confidence. His grades have improved significantly"
    },
    { 
      name: 'Parent of Grade 11 Student, Sharjah',
      role: 'Parent', 
      text: "My daughter needed help with AP Calculus and AP Biology. Engagehub quickly connected us to specialized tutors who understood the AP curriculum thoroughly. The sessions were structured, effective, and results-driven. She now feels fully prepared for her exams."
    },
    { 
      name: 'Parent of High School Junior, UAE',
      role: 'Parent', 
      text: "As parents, we were concerned about choosing the right services for our child. Engagehub gave us a list of vetted SAT prep and tutoring providers, making the decision much easier. It was reassuring to know that every recommendation was trustworthy and proven"
    }
  ];

  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [testimonials.length]);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) => (prev + 1) % testimonials.length);
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) => (prev - 1 + testimonials.length) % testimonials.length);
  };

  return (
    <div className="consultancy-page">
      {/* Hero Section */}
      <section className="consultancy-hero" style={{backgroundImage: "url('/c.jpg')"}}>
        <div className="hero-content">
          <h1 className="hero-title">
            University Education <span className="highlight">Consultants</span> for
            Top Universities
          </h1>
          <p className="hero-subtitle">
            Empowering students with expert guidance for admissions, career
            planning, and global opportunities.
          </p>
          <a href="/contact"> <button className="cta-btn">Book a Free counselling</button> </a>
        </div>
      </section>

      {/* Why Us & Testimonials Section */}
      <section className="why-us-testimonials-section">
        <div className="why-us-container">
          {/* Left Side - Why Us */}
          <motion.div 
            className="why-us-content"
            initial={{ opacity: 0, x: -50 }}
            whileInView={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6 }}
            viewport={{ once: true }}
          >
            <h2 className="why-us-title">Why Us ?{/*<span className="highlight">EngageHub?</span>*/}</h2>
            <p className="why-us-description">
              At EngageHub, we craft compelling narratives that elevate your application above the rest. Our expert consultants combine global experience with personalized strategy, guiding you from profile refinement through admission success. We don't just guide you through the process; we partner with you every step of the way. With our proven methodology and strong record of placements, we help you unlock the door to your dream university. Your aspirations deserve excellence. Choose EngageHub for consultancy that delivers results.
            </p>
            {/*
            <div className="why-us-features">
              <div className="feature-item">
                <div className="feature-icon">🎓</div>
                <div className="feature-text">
                  <h3>Expert Guidance</h3>
                  <p>Over a decade of experience helping students achieve their academic dreams</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🌍</div>
                <div className="feature-text">
                  <h3>Global Network</h3>
                  <p>Direct connections with top universities across UK, USA, Canada, Europe & Asia</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">💯</div>
                <div className="feature-text">
                  <h3>100% Success Rate</h3>
                  <p>Proven track record of successful admissions since establishment</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">🤝</div>
                <div className="feature-text">
                  <h3>End-to-End Support</h3>
                  <p>From application to enrollment and beyond - we're with you every step</p>
                </div>
              </div>
              <div className="feature-item">
                <div className="feature-icon">📝</div>
                <div className="feature-text">
                  <h3>Personalized Approach</h3>
                  <p>Tailored strategies based on your unique strengths and aspirations</p>
                </div>
              </div>
            </div>*/}
          </motion.div>

          {/* Right Side - Testimonials Carousel */}
          <motion.div 
            className="testimonials-carousel-consultancy"
            
          >
            <h2 className="testimonials-title">Student <span className="highlight">Success Stories</span></h2>
            <div className="testimonial-card">
              <div className="testimonial-content">
                <div className="quote-icon">"</div>
                <p className="testimonial-text">{testimonials[currentTestimonial].text}</p>
                <div className="testimonial-author">
                  <div className="author-info">
                    <h4>{testimonials[currentTestimonial].name}</h4>
                    <p>{testimonials[currentTestimonial].role}</p>
                  </div>
                </div>
              </div>
            </div>
            
            <div className="carousel-controls">
              <button className="carousel-btn prev" onClick={prevTestimonial}>‹</button>
              <div className="carousel-dots">
                {testimonials.map((_, index) => (
                  <span 
                    key={index} 
                    className={`dot ${index === currentTestimonial ? 'active' : ''}`}
                    onClick={() => setCurrentTestimonial(index)}
                  ></span>
                ))}
              </div>
              <button className="carousel-btn next" onClick={nextTestimonial}>›</button>
            </div>
          </motion.div>
        </div>
      </section>

      {/* UCAS Section /}
      <section className="ucas-section">
        <div className="ucas-container">
          <article className="ucas-card1">
            <h2>EngageHub Overseas Education Consultants</h2>
            <p>
              We are happy to find our students coming out with flying colours and conquering greater heights in life. To deliver the best to the students, we constantly monitor and improve upon our services with changes happening in the world of education. EngageHub has outperformed the competitors and adjudged as the best education consultants through unparalleled dedication and service. EngageHub provides admission consultation for top universities across the globe, including Stanford, Harvard, UCLA, and Cambridge, amongst others. The student-centric and result-focussed methodology adopted by EngageHub has been fruitful until today. And we have accomplished cent percent success since establishment. Our professional and experienced abroad education consultants have more than a decade of experience. They will identify the passion, ambition, and tastes of the students before advising them about the best course. Thereby, the aspirants can accomplish their long-cherished dream without much difficulty. EngageHub offers international education consultation for Bachelors, Masters, and Doctoral programs. The professional support will not only be limited to admission but also will extend during the course. The diligent and caring attitude from EngageHub will act as a guardian angel for you during the course. Contact EngageHub for education consultation in the UK, USA, Canada, Europe, and Asia. We offer a complete package commencing from the initial application to the conclusion. You can remain unconcerned about the admission and concentrate on your studies once you assign us with the task of admission. Being one of the leading education consultancy, we assure the best services for abroad education and other domestic education purposes.
            </p>
          </article>

          <article className="ucas-card2">
            <h2>Why EngageHub Education Consultants</h2>
            <p>
              EngageHub has an extensive experience in the field of overseas education consultation, online tutoring for subjects, and competitive exams. EngageHub plays an active role in preparing road map for students to study abroad. The major benefits of EngageHub education consultants range from the comprehensive and exclusive support services, help to select Universities, guidance is application and admission procedures, a lot more. Given below are the top reasons to choose EngageHub as your international education consultant.
            </p>
          </article>

          <article className="ucas-card3">
            <h2>Comprehensive Assistance</h2>
            <p>
              EngageHub extends comprehensive assistance in education consultation. When it comes to overseas education consultation, it begins with the selection of the right university and concludes in enrolment of the student in the University of his or her choice.
            </p>
          </article>

          <article className="ucas-card4">
            <h2>Thorough Analysis for Selection of the University</h2>
            <p>
              As an abroad education consultant, we do not just provide a list of universities. On the other hand, we will examine the student's performance in various subjects, extracurricular activities, tastes in different fields and subjects, budget limitations, climatic options by the students, and similar aspects. A complete list of optional universities will be proposed to the student, from the best universities in the UAE, US, UK, Canada, Europe, and Asia. The apt university will be finalized post discussion with the students and parents.
            </p>
          </article>

          <article className="ucas-card5">
            <h2>Concerted Efforts to Obtain Admission</h2>
            <p>
              Obtaining admissions in the most sought-after universities is not an easy task. It necessitates concerted and calculated steps to narrate the eminence of the student and state why he or she deserves to be admitted. Our professionals will sit down to prepare a pen picture of the student after detailed and in-depth discussion sessions. The CVs, letters, narratives, recommendations, and interviews will illustrate the student's unique qualities and will be instrumental in gaining admission.
            </p>
          </article>

          <article className="ucas-card6">
            <h2>Guidance in Application Process</h2>
            <p>
              Each university and college has its specific application procedure. We will guide the students regarding the same and help the student to pursue the process without any confusion or errors. The timing of universities admission in the UK, USA, Canada, Europe, and Asia will differ. The professionals empanelled at EngageHub will aid the students to prepare a calendar with dates of tests, interviews, results etcetera, which will enable the student to monitor the progress. In addition to the above-mentioned, EngageHub will assist the students in interview preparation, CV creation, and formatting. And will provide you unlimited email access to clarify doubts at every step of the admission process. Right from home education to abroad education, EngageHub a one-stop-solution for all your educational requirements. Renowned as one of the popular education consultants and one of the most reputed international education consultants, EngageHub offers a platform that links students with universities, helping them select a right decision with minimal effort. Besides overseas educational consultation, we deliver both online and classroom coaching for UCAT, SAT, ACT, GMAT and GRE. The online and classroom tuitions for Maths, Biology, Physics, Chemistry, English, Business, Psycology and Economics, by exceptionally qualified tutors from around the world, will strengthen you to attend any exam with confidence.
            </p>
          </article>
        </div>
      </section>

      {/* How It Works Section */}
      <section className="tutoring-section how-it-works">
        <div className="section-header">
          <h2 className="section-title">How We Do It</h2>
          <p className="section-subtitle">
            Your journey to academic success 
          </p>
        </div>

        <div className="steps-container">
          {[
            {
              num: "1",
              title: "Initial counselling and Profile Evaluation",
              desc: "Register and book your first free class with our expert tutor. Get a personalized assessment of your current level.",
            },
            {
              num: "2",
              title: "Goal Setting and Personalized Roadmap",
              desc: "We create a personalized plan based on your learning goals, pace, and areas that need improvement.",
            },
            {
              num: "3",
              title: "Application and Exam Preparation Support",
              desc: "Regular tests, detailed feedback, and parent updates to track performance and celebrate achievements.",
            },
            {
              num: "4",
              title: "Submission and Follow-Up Assistance",
              desc: "We create a personalized plan based on your learning goals, pace, and areas that need improvement.",
            },
            {
              num: "5",
              title: "Pre-Departure Guidance and Career Mentorship",
              desc: "We create a personalized plan based on your learning goals, pace, and areas that need improvement.",
            },
          ].map((step, i) => (
            <motion.div
              className="step-card"
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              viewport={{ once: true }}
            >
              <div className="step-number">{step.num}</div>
              <h3 className="step-title">{step.title}</h3>
              <p className="step-desc">{step.desc}</p>
            </motion.div>
          ))}
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta-section">
        <h2>Ready to Begin Your Journey?</h2>
        <p>
          Get expert guidance tailored to your academic and career aspirations.
        </p>
        <a href="/contact">
          <button className="cta-btn">Get Started Today</button>
        </a>
      </section>
    </div>
  );
};

export default Consultancy;